<template>
    <div>
        ZAGLUSHKA Offers
    </div>
</template>

<script>
export default {
    name: "Offers"
}
</script>

<style scoped>

</style>
